import { css } from 'lit';

export const slideHtmlStyles = css`
  :host {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
  }

  :host([header]) {
    justify-content: flex-end;
  }

  #editor,
  #content {
    position: relative;
    padding: 0.5cqi 4cqi 2cqi 4cqi;
    -webkit-appearance: none;
    font-family: var(--screen-slide-text-font), serif;
    font-weight: 400;
    font-size: 2.7cqi;
    line-height: 130%;
    pointer-events: all;
    cursor: default;
  }

  :host([layout-position='right']) #editor,
  :host([layout-position='right']) #content {
    padding-left: 2cqi;
  }

  :host([header]) #editor,
  :host([header]) #content {
    padding-top: 2cqi;
    padding-bottom: 0.7cqi;
    font-family: var(--screen-slide-header-font), sans-serif;
    font-weight: 600;
    font-size: 3.9cqi;
    line-height: 106%;
  }

  :host([text-align='center']) #editor,
  :host([text-align='center']) #content {
    text-align: center;
  }

  :host([text-align='rigth']) #editor,
  :host([text-align='right']) #content {
    text-align: right;
  }

  p {
    margin-top: 0.8cqi;
    margin-bottom: 1cqi;
    margin-block-start: 0.8cqi;
    margin-block-end: 1cqi;
  }

  p:first-child,
  h1:first-child,
  h2:first-child,
  ul:first-child,
  ol:first-child {
    margin-top: 0;
    margin-block-start: 0;
  }

  p:last-child,
  h1:last-child,
  h2:last-child,
  ul:last-child,
  ol:last-child {
    margin-bottom: 0;
    margin-block-end: 0;
  }

  ul {
    margin: 0;
    padding: 0 0 0 2.5cqi;
    padding-inline-start: 4cqi;
    margin-block-start: 1cqi;
    margin-block-end: 1cqi;
  }

  li {
    margin-bottom: 0.5cqi;
  }

  strong {
    font-weight: 600;
  }
`;
